export const PERMISSION_VALUES = {
    PROFILE:"PROFILE",
    LEGAL_DOCUMENTS:"LEGAL_DOCUMENTS",
    SUPPORT:"SUPPORT",
    DASHBOARD:"DASHBOARD",
    USER:"USER",
}


export const PERMISSIONS_ARRAY = [
  {
    title: "Profile",
    value: PERMISSION_VALUES.PROFILE,
    read: true,
    create: false,
    edit: false,
    delete: false,
  },
  {
    title: "Legal Documents",
    value: PERMISSION_VALUES.LEGAL_DOCUMENTS,
    read: true,
    create: false,
    edit: false,
    delete: false,
  },
  {
    title: "Support",
    value: PERMISSION_VALUES.SUPPORT,
    read: true,
    create: false,
    edit: false,
    delete: false,
  },
  {
    title: "Dashboard",
    value: PERMISSION_VALUES.DASHBOARD,
    read: true,
    create: false,
    edit: false,
    delete: false,
  },
  {
    title: "User",
    value: PERMISSION_VALUES.USER,
    read: true,
    create: false,
    edit: false,
    delete: false,
  },
];
